import PropTypes from 'prop-types';

const CategoryCard = ({ title, previewImage, url, target }) => (
  <a
    href={url}
    className="d-block image-hover position-relative gradient-overlay rounded overflow-hidden"
    target={target || '_self'}
  >
    <h3 className="experience-category-card__title gradient-overlay__content position-absolute text-white fw-normal">
      {title}
    </h3>
    <img
      loading="lazy"
      src={previewImage.url}
      alt={previewImage.alt}
      width={previewImage.width}
      height={previewImage.height}
    />
  </a>
);

export default CategoryCard;

CategoryCard.propTypes = {
  title: PropTypes.string.isRequired,
  previewImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
  }),
  url: PropTypes.string.isRequired,
  target: PropTypes.string,
};
